import style from '../styles/form.module.css'

import PaymentMethod from './PaymentMethod'
import classNames from 'classnames/bind'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'
import Link from 'next/link'
import useUser from '../hooks/useUser'

export default function PaymentMethods ({ type = 'deposit', currency, instant, selected, onSelect }) {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const { account } = useUser()

  const depositMethods = []
  // !instant &&
  depositMethods.push({
    id: 1,
    type: 'paynow',
    name: t('transactions-type-paynow'),
    currencies: ['SGD'],
    percentFeeFunc: function () { return 0 }
  })
  depositMethods.push({
    id: 2,
    type: 'bank',
    name: t('transactions-type-bank'),
    currencies: ['SGD', 'USD', 'AUD', 'CAD', 'HKD', 'GBP', 'CHF', 'EUR', 'JPY'],
    percentFeeFunc: function () { return 0 }
  })
  depositMethods.push({
    id: 3,
    type: 'creditcard',
    name: t('transactions-type-creditcard'),
    currencies: ['SGD', 'USD']
  })

  const withdrawalMethods = account?.Treasuries?.filter(t => t.Currency === currency).map(t => ({
    id: t.Id,
    type: t.Type.toLowerCase(),
    name: t.AccBankName + ' ' + t.AccNr,
    currencies: [t.Currency],
    percentFeeFunc: function () { return 0 }
  })) || []

  const methods = type === 'deposit' ? depositMethods.filter(s => s.currencies.includes(currency)) : withdrawalMethods

  useEffect(() => {
    const method = methods.find(s => s.id === selected && s.currencies.includes(currency))
    onSelect(method || (methods.length === 1 ? methods[0] : {}))
  }, [type, selected, currency, account])

  return type === 'deposit' && !methods?.length
    ? (
      <>
        {t('paymentmethods-deposit-nomethods')} <Link href='/deposit'><a>{t('paymentmethods-deposit-depositfirst-link')}</a></Link>
        <br /><br />
      </>
    )
    : (
      <>
        {/* {transfer?.type === 'deposit' &&
          <Link href='/newpaymentmethod'>
            <a className={c('right')}>
              Add new
            </a>
          </Link>}
        */}
        <h3>
          {type === 'deposit'
            ? (instant ? t('paymentmethods-deposit-selectpaymentmethod-instant') : t('paymentmethods-deposit-selectpaymentmethod'))
            : t('paymentmethods-withdraw-selectpaymentmethod')}
        </h3>
        <ul className={c('inputfield')}>
          {methods && !!methods.length && methods.map(pm =>
            (
              <li key={type + pm.id}>
                <PaymentMethod
                  {...pm}
                  onSelect={e => onSelect(pm)}
                  selected={selected === pm.id}
                />
              </li>
            )
          )}
          {!methods?.length && type === 'withdraw' && (
            <li>
              {t('paymentmethods-withdraw-accountsettings')}
              <br /><br />
              <Link href='/settings/withdrawals'><a>{t('paymentmethods-withdraw-accountsettings-link')}</a></Link>
            </li>
          )}
          {/* instant && (
            <li>
              {t('paymentmethods-deposit-instantinfo')} <Link href='/deposit'><a>{t('paymentmethods-deposit-depositfirst-link')}</a></Link>
            </li>
          ) */}
        </ul>
      </>
    )
}
